var header_value = {
  isoLanguage: "en",
  isoCountry: "CA",
  brandCode: "BHA361",
  brandDescription: "Liquid IV",
  campaignId: "PN005184",
  campaignDescription: "Liquid IV",
  origin: "www.liquid-iv.ca",
  formType: "signUp",
  entity: "PRM2.6",
};
console.log("gigya_header_value: ", header_value);
$("body").on(
  "click",
  "form#contact_form .global-button.global-button--primary",
  function (e) {
    $(this).val("Processing..");
    $(".error_msg").text("");
    e.preventDefault();
    gigya_code_subscription(header_value);
  }
);
$("body").on("click", "#new_button_submit", function (e) {
  $(".error_msg").text("");
  gigya_code(header_value);
});
function gigya_code(header_value) {
  var canonicalUrl = $('link[rel="canonical"]').attr("href");
  if (
    $("input#email").val() == "" ||
    $("input#first_name").val() == "" ||
    $("input#last_name").val() == "" ||
    $("input#postal_code").val() == ""
  ) {
    if (canonicalUrl == "https://www.liquid-iv.ca/pages/signup") {
      $(".error_msg").text("Please fill in all the required fields");
      $("form#create_customer .global-button.global-button--primary").val("Sign Up");
      return false;
    } else if (canonicalUrl == "https://www.liquid-iv.ca/fr/pages/signup") {
      $(".error_msg").text("Veuillez remplir tous les champs obligatoires");
      $("form#create_customer .global-button.global-button--primary").val("S'inscrire");
      return false;
    }
  } else {
    var postalCode = $("#postal_code").val();
    console.log("Postal Code: ", postalCode);
    const regex = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;
    var birthday = $("#birthday").val();
    console.log("Birthday: ", birthday);
    if (regex.test(postalCode)) {
      $(".postal_error_msg").text("");
      if ($(".accepts_marketing_customer").is(":checked")) {
        // $(".postal_error_msg").text("");
      } else {
        if (canonicalUrl == "https://www.liquid-iv.ca/pages/signup") {
          alert("Please check on legal consent checkbox");
          $("form#create_customer .global-button.global-button--primary").val("Sign Up");
          return false;
        } else if (canonicalUrl == "https://www.liquid-iv.ca/fr/pages/signup") {
          alert("Veuillez cocher la case de consentement légal");
          $("form#create_customer .global-button.global-button--primary").val("S'inscrire");
          return false;
        }
      }
    } else {
      if (canonicalUrl == "https://www.liquid-iv.ca/pages/signup") {
        $(".postal_error_msg").text("Please specify a valid postal code");
        $("form#create_customer .global-button.global-button--primary").val("Sign Up");
        return false;
      } else {
        $(".postal_error_msg").text("Veuillez préciser un code postal valide");
        $("form#create_customer .global-button.global-button--primary").val("S'inscrire");
        return false;
      }
    }
  }
  console.log(
    "Legal checkbox value: " + $(".accepts_marketing_customer").is(":checked")
  );
  var optInStatus_value = { 
    legalAgeConsent: true,
    unileverEmailConsent: true,
  };
  var data_value = JSON.stringify({
    profile: {
      header: header_value,
      consumerIdentity: {
        firstName: $("input#first_name").val(),
        lastName: $("input#last_name").val(),
        dateOfBirth: $("input#birthday").val(),
      },
      contactDetail: { 
        email: $("input#email").val(),
        address: {
          postalCode: $("input#postal_code").val(),
          addressCountry: "CA",
        },
      },
      optInStatus: optInStatus_value,
    },
  });
  console.log("gigya_data_value: ", data_value);
  var settings = {
    url: "https://forms-us.unileversolutions.com/v3",
    method: "POST",
    timeout: 0,
    headers: {
      "x-api-key": "389c1006-e9eb-4fb1-9ce0-6577dac7b3a2",
      "Content-Type": "application/json",
    },
    data: data_value,
  };

  $.ajax(settings)
    .done(function (response) {
      console.log(response);
      createCookie(response);
      $("#create_customer").submit();
      if (canonicalUrl == "https://www.liquid-iv.ca/pages/signup") {
        $("#new_button_submit").val("Processing..");
        window.location.href = "https://www.liquid-iv.ca/pages/signup-thank-you";
      } else if (canonicalUrl == "https://www.liquid-iv.ca/fr/pages/signup") {
        $("#new_button_submit").val("Traitement..");
        window.location.href = "https://www.liquid-iv.ca/fr/pages/signup-thank-you";
      }
    })
    .fail(function (response) {
      console.log(response.responseText);
      var errorObject = JSON.parse(response.responseText);
      console.log(errorObject);
      var errorObject_1 = errorObject.downstreamApiResponse;
      var errorObject_2 = errorObject_1.Value;
      console.log(errorObject_1);
      console.log(errorObject_2);
      $(".error_msg").text(errorObject_2);
      $("form#create_customer .global-button.global-button--primary").val("Sign Up");
    });
}

function gigya_code_subscription(header_value) {
  var optInStatus_value = { 
    legalAgeConsent: true,
    unileverEmailConsent: true,
  };
  if (
    $("input#subscribeFristName").val() == "" ||
    $("input#subscribeLastName").val() == "" ||
    $("input#subscribeEmail").val() == "" ||
    $("input#subscribePostal").val() == "" ||
    $("input#subscribeDOB").val() == ""
  ) {
    $(".error_msg").text("Please fill in all the required fields");
    $("form#contact_form .global-button.global-button--primary").val("Subscribe");
    return false;
  }

  var dob_data = $("input#subscribeDOB").val();
  console.log(dob_data);
  if (dob_data.match("/") != null) {
    var dob_data_array = dob_data.split("/");
    console.log(dob_data_array);
    var dob_data_value =
      dob_data_array[2] + "-" + dob_data_array[1] + "-" + dob_data_array[0];
  } else {
    var dob_data_array = dob_data.split("-");
    console.log(dob_data_array);
    var dob_data_value =
      dob_data_array[2] + "-" + dob_data_array[1] + "-" + dob_data_array[0];
  }
  console.log(dob_data_value);
  var data_set = JSON.stringify({
    profile: {
      header: header_value,
      consumerIdentity: {
        firstName: $("input#subscribeFristName").val(),
        lastName: $("input#subscribeLastName").val(),
        dateOfBirth: dob_data_value,
      },
      contactDetail: {
        email: $("input#subscribeEmail").val(),
        address: {
          postalCode: $("input#subscribePostal").val(),
          addressCountry: "CA",
        },
      },
      optInStatus: optInStatus_value,
    },
  });
  console.log(header_value);
  console.log(data_set);
  var settings = {
    url: "https://forms-us.unileversolutions.com/v3",
    method: "POST",
    timeout: 0,
    headers: {
      "x-api-key": "389c1006-e9eb-4fb1-9ce0-6577dac7b3a2",
      "Content-Type": "application/json",
    },
    data: data_set,
  };

  $.ajax(settings)
    .done(function (response) {
      console.log(response);
      createCookie(response);
      $("#contact_form").submit();
    })
    .fail(function (response) {
      console.log(response.responseText);
      var errorObject = JSON.parse(response.responseText);
      console.log(errorObject);
      var errorObject_1 = errorObject.downstreamApiResponse;
      var errorObject_2 = errorObject_1.Value;
      console.log(errorObject_1);
      console.log(errorObject_2);
      $(".error_msg").text(errorObject_2);
      $("form#contact_form .global-button.global-button--primary").val(
        "Subscribe"
      );
    });
}

function createCookie(id) {
  console.log("Success:", id);
  const d = new Date();
  d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie =
    "UnileverId=" + id["UnileverId"] + ";" + expires + ";path=/";
}
